





















import { Component, Prop, Vue } from 'vue-property-decorator';
import {ProfileField} from "../../../../../types/ProfileField";
import {UserProfile} from "@api/models/UserProfile";
import ControlWrapperBorderless from "@share/common/ControlWrapperBorderless.vue";
import BorderlessTextarea from "@share/common/form/form-controls/text/BorderlessTextarea.vue";

@Component({
    name: 'ProfileFieldInput',
    components: { ControlWrapperBorderless, BorderlessTextarea }
})
export default class InfoPart extends Vue {
    @Prop({required: true}) field: ProfileField;
    @Prop({required: true}) profile: UserProfile;
    @Prop({required: true}) validationMessages: Record<string, string>;

    caption(field: ProfileField) {
        const language = this.$store.state.session?.language ?? 'en';

        return field && field.title && field.title[language]
            ? field.title[language]
            : this.$t('settings.' + field.name.toLowerCase());
    }
}
